import React from "react"
import { useContext } from 'react';
import { PhoneWidgetContext } from './provider';

export default function usePhoneWidget() {
    const context = useContext(PhoneWidgetContext)

    if (!context) throw new Error('usePhoneWidget must be used within a PhoneWidgetProvider')

    return context
}
